export default __webpack_public_path__ + "static/media/aran.0c4b726e.png";